import { IonButton, IonContent, IonPage, NavContext } from '@ionic/react';
import { useCallback, useContext } from 'react';

import logo from '@/assets/images/logo/logo-with-icon.png';
import { ButtonContainer, Padding, Promo } from '@/components/common';
import { Text } from '@/components/memo';
import { useDentist } from '@/contexts';
import { ROUTES } from '@/utils/routes';

import './NoAccess.css';

const NoAccess: React.FC = () => {
  const { selectDentist } = useDentist();
  const { navigate } = useContext(NavContext);

  const copy = {
    promo: {
      header: (
        <>
          No <Text color="primary">access</Text> given!
        </>
      ),
      subHeader:
        'Please contact your clinic administrator to request access to your schedule.'
    },
    backButtonText: 'Go back'
  };

  const onBack = useCallback(async () => {
    await selectDentist(null);
    navigate(ROUTES.SELECT_DENTIST);
  }, [selectDentist, navigate]);

  return (
    <IonPage id="no-access">
      <IonContent scrollX={false} scrollY={false}>
        <Padding>
          <div className="no-access__promo-container">
            <Promo
              image={logo}
              imageStyle={{ maxWidth: 192 }}
              header={copy.promo.header}
              subHeader={copy.promo.subHeader}
            />
          </div>
          <ButtonContainer>
            <IonButton
              id="back-button"
              onClick={onBack}
              expand="block"
              fill="solid"
              size="default"
              color="primary"
              strong={true}
            >
              {copy.backButtonText}
            </IonButton>
          </ButtonContainer>
        </Padding>
      </IonContent>
    </IonPage>
  );
};

export default NoAccess;
